import { render } from "./RegisterPopup.vue?vue&type=template&id=0c95e930&scoped=true&ts=true"
import script from "./RegisterPopup.vue?vue&type=script&lang=ts"
export * from "./RegisterPopup.vue?vue&type=script&lang=ts"

import "./RegisterPopup.vue?vue&type=style&index=0&id=0c95e930&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c95e930"]])

export default __exports__